import { render, staticRenderFns } from "./ItemsSelectionSection.vue?vue&type=template&id=510a0105&scoped=true"
import script from "./ItemsSelectionSection.vue?vue&type=script&lang=js"
export * from "./ItemsSelectionSection.vue?vue&type=script&lang=js"
import style0 from "./ItemsSelectionSection.vue?vue&type=style&index=0&id=510a0105&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510a0105",
  null
  
)

export default component.exports